import { reducer } from '../reducers/evaluationFiltersReducer'
import { useReducer, useCallback } from "react";

import {
    SET_ID_SELECTED_ACTION,
    SET_DEPARTMENTS_ACTION,
    SET_DATE_SELECTED_ACTION,
    SET_DEPARTMENT_SELECTED_ACTION,
    SET_UNIVERSITY_SELECTED_ACTION,
    SET_ERASMUS_CODE_SELECTED_ACTION,
    SET_COUNTRY_SELECTED_ACTION,
    SET_DEPARTMENTAL_COORDINATOR_SELECTED_ACTION,
    SET_IIA_DEPARTMENT_SELECTED_ACTION,
    SET_TYPE_SELECTED_ACTION,
    SET_IS_MODAL_OPEN_ACTION,
    SET_SORT_SELECTED_ACTION
} from '../reducers/evaluationFiltersReducer'

export const defaultState = {
    idSelected: "",
    departments: "",
    dateSelected: "",
    typeSelected: "",
    departmentSelected: "",
    universitySelected: "",
    erasmusCodeSelected: "",
    countrySelected: "",
    departmentalCoordinatorSelected: "",
    iiaDepartmentSelected: "",
    sortSelected: "",
    isModalOpen:false
}

export const useEvaluationFilter = (initialState = defaultState) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    const setIdSelected = useCallback((data) => {
        dispatch({ type: SET_ID_SELECTED_ACTION, payload: { idSelected: data } })
    })

    const setDepartments = useCallback((data) => {
        dispatch({ type: SET_DEPARTMENTS_ACTION, payload: { departments: data } })
    })

    const setDateSelected = useCallback((data) => {
        dispatch({ type: SET_DATE_SELECTED_ACTION, payload: { dateSelected: data } })
    })

    const setTypeSelected = useCallback((data) => {
        dispatch({ type: SET_TYPE_SELECTED_ACTION, payload: { typeSelected: data } })
    })


    const setDepartmentSelected = useCallback((data) => {
        dispatch({ type: SET_DEPARTMENT_SELECTED_ACTION, payload: { departmentSelected: data } })
    })

    const setUniversitySelected = useCallback((data) => {
        dispatch({ type: SET_UNIVERSITY_SELECTED_ACTION, payload: { universitySelected: data } })
    })

    const setErasmusCodeSelected = useCallback((data) => {
        dispatch({ type: SET_ERASMUS_CODE_SELECTED_ACTION, payload: { erasmusCodeSelected: data } })
    })

    const setCountrySelected = useCallback((data) => {
        dispatch({ type: SET_COUNTRY_SELECTED_ACTION, payload: { countrySelected: data } })
    })

    const setDepartmentalCoordinatorSelected = useCallback((data) => {
        dispatch({ type: SET_DEPARTMENTAL_COORDINATOR_SELECTED_ACTION, payload: { departmentalCoordinatorSelected: data } })
    })

    const setIiaDepartmentSelected = useCallback((data) => {
        dispatch({ type: SET_IIA_DEPARTMENT_SELECTED_ACTION, payload: { iiaDepartmentSelected: data } })
    })

    const setIsModalOpen = useCallback((data) => {
        dispatch({ type: SET_IS_MODAL_OPEN_ACTION, payload: { isModalOpen: data } })
    })
    
    const setSortSelected = useCallback((data) => {
        dispatch({ type: SET_SORT_SELECTED_ACTION, payload: { sortSelected: data } })
    })

    return {
        state,
        setIdSelected,
        setDepartments,
        setDateSelected,
        setTypeSelected,
        setDepartmentSelected,
        setUniversitySelected,
        setErasmusCodeSelected,
        setCountrySelected,
        setDepartmentalCoordinatorSelected,
        setIiaDepartmentSelected,
        setSortSelected,
        setIsModalOpen
    }
}
